import React from 'react';
import me from '../assets/Images/me.jpg';
// import { aboutData } from '../data/aboutData';

// const StackImages = ({ img }) => {
//   return <img src={img} />;
// };
const About = () => {
  return (
    <div className="about-wrapper">
      <div className="title">
        <h2>About Me</h2>
        <div className="line"></div>
      </div>
      <div className="container">
        <div className="profile">
          <img src={me} alt="" className="image" />
          <div className="icons">
            {/* {aboutData.map((img) => {
              return <StackImages key={img.id} {...img} />;
            })} */}
          </div>
        </div>
        <div className="about-me">
          <div className="top">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="bottom">
            <p>
              JavaScript and React Software Engineer based in Nairobi, Kenya. <br />
              With an analytic and technical mindset combined with creativity
              and graphic design skills to problem solve. Building responsive
              and dynamic websites across all platforms. I have brought to life
              great designs through my web development skills. I am looking
              forward to bringing my tenacity and results-driven performance to
              your business.
              <br />
              When I'm not coding, you will find me outdoors. I love being out
              in nature whether that's going for a walk, run or cycling.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
